window.Typeahead = require('typeahead');

$('#languagePicker').change(function () {
    $.busyLoadFull("show");
    Ajax.post('/change_language/' + $('#languagePicker').val(), {})
        .then(response => {
            if (response.data.success) {
                location.reload();
                $.busyLoadFull("hide");
            } else {
                notifier.alert ('Failed to load selected language');
                $.busyLoadFull("hide");
            }
        })
        .catch(error => {
                if (error) {
                    const response = error.response;
                    if ((response.status === 422) && (response.data.errors)) {
                        notifier.alert(response.data.errors);
                        $.busyLoadFull("hide");
                    } else {
                        notifier.alert('An unknown error occurred when trying to change language.');
                        $.busyLoadFull("hide");
                    }
                }
            }
        )
    ;

});